export default "__VITE_ASSET__DaGnitc8__"